import { defineMessages } from 'react-intl';

const messages = defineMessages({
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  widgetInfo: {
    id: 'hkdb5L',
    defaultMessage:
      'Please follow the dropdown menu below and  answer the questions to let us understand your financial and operational asset maintenance profile.  We will instantly assess the potential benefits of Maximo to your business.',
  },
  widgetText_1: {
    id: 'WXSfCt',
    defaultMessage: 'See your potential benefit',
  },
  accordionTitle_1: {
    id: 'xRglVq',
    defaultMessage: 'Increase maintenance productivity',
  },
  accordionDesc_1: {
    id: '8rqbR6',
    defaultMessage:
      'This benefit estimates the opportunity to increase the productivity of asset management and maintenance related roles such as Reliability Engineers, Maintenance Planners, Maintenance Supervisors, and Maintenance Technicians.',
  },
  accordionTitle_2: {
    id: 'YmJvtm',
    defaultMessage: 'Reduce external maintenance spend',
  },
  accordionDesc_2: {
    id: 'cUkc/u',
    defaultMessage:
      'This benefit estimates the opportunity to reduce or avoid cost related to maintenance services provided by external providers.',
  },
  accordionTitle_3: {
    id: 'Dgnwqr',
    defaultMessage: 'Reduce downtime cost',
  },
  accordionDesc_3: {
    id: 'GftFDv',
    defaultMessage:
      'This benefit estimates the opportunity to reduce the economic cost of planned or unplanned downtime by improving the availability and performance of assets. ',
  },
  accordionTitle_4: {
    id: 'wJphaF',
    defaultMessage: 'Extend useful life of assets',
  },
  accordionDesc_4: {
    id: 'qGy3Wi',
    defaultMessage:
      'This benefit estimates the opportunity to reduce asset replacement and overhaul cost by extending the economic and average useful life of assets and equipment.',
  },
  accordionTitle_5: {
    id: 'LG9hno',
    defaultMessage: 'Reduce MRO parts and supplies cost',
  },
  accordionDesc_5: {
    id: 'xfXaOY',
    defaultMessage:
      'This benefit estimates the opportunity to reduce the spend for Maintenance, Repair, and Operations (MRO) materials and supplies that are used to maintain and repair assets.',
  },
  accordionTitle_6: {
    id: 'l5I6KL',
    defaultMessage: 'Rationalize asset management tools',
  },
  accordionDesc_6: {
    id: 'j05Xut',
    defaultMessage:
      'This benefit estimates the opportunity to reduce and consolidate disparate asset management related applications, tools, and associated IT costs.',
  },
  maintenanceFTEsLabel: {
    id: 'qTW+Kp',
    defaultMessage: 'Number of Maintenance Personnel (Full-Time-Equivalents)',
  },
  maintenanceFTEsDescTootlip: {
    id: '/WSzMH',
    defaultMessage:
      'Number of Maintenance Personnel in scope across maintenance roles based on full-time-equivalent headcount. ',
  },
  maintenancePersonProdLabel: {
    id: 'W5bHzC',
    defaultMessage: 'Estimated Maintenance Personnel Productivity Improvement',
  },
  maintenancePersonProdDescTooltip: {
    id: '/HOnsL',
    defaultMessage:
      'Estimated average productivity improvement by reducing unnecessary maintenance activities and increasing the cost efficient execution of necessary tasks. ',
  },
  maintenancePersonFTERateLabel: {
    id: 'MSiggH',
    defaultMessage: 'Average Maintenance Personnel - Annual Cost Rate',
  },
  maintenancePersonFTERateDescTooltip: {
    id: 'FV1smI',
    defaultMessage:
      'Average annual cost per maintenance personnel headcount (blended rate; fully loaded)',
  },
  extMaintenanceVendorSpendLabel: {
    id: 'y17fxD',
    defaultMessage: 'External Maintenance Vendor Spend',
  },
  extMaintenanceVendorSpendDescTooltip: {
    id: 'XXZbPZ',
    defaultMessage:
      'Current annual spend with external maintenance vendors to provide maintenance services.',
  },
  extMaintVendorSpendReduceLabel: {
    id: 'opcXik',
    defaultMessage: '% External Maintenance Vendor Spend Reduction',
  },
  extMaintVendorSpendReduceDescTooltip: {
    id: 'qQSCP8',
    defaultMessage:
      'Estimated reduction in external maintenance vendor spend by reducing unnecessary maintenance activities and increasing the cost efficiency of necessary tasks. ',
  },
  downTimeHoursAnnualLabel: {
    id: 'ziW66V',
    defaultMessage: 'Annual Downtime Hours',
  },
  downTimeHoursAnnualDescTooltip: {
    id: 'OJFdto',
    defaultMessage:
      'Number of hours per year that assets are not available due to maintenance related issues that adversely impact operations. ',
  },
  downTimeReduceLabel: {
    id: 'gPtYYm',
    defaultMessage: '% Downtime Reduction',
  },
  downTimeReduceDescTooltip: {
    id: '8Ar0Nj',
    defaultMessage:
      'Estimated reduction in downtime due to increased availability and performance of assets. ',
  },
  downTimePerHrCostLabel: {
    id: 'iytbrM',
    defaultMessage: 'Average Economic Cost of Downtime per hour',
  },
  downTimePerHrCostDescTooltip: {
    id: '43hx5I',
    defaultMessage:
      'Estimated average economic cost per downtime hour (e.g., cost of lost production, profit impact from lost sales)',
  },
  replaceAssetsBudgetLabel: {
    id: 'KIgTZ/',
    defaultMessage: 'Annual CapEx Budget to Replace/Overhaul Assets',
  },
  replaceAssetsBudgetDescTooltip: {
    id: 'I7+dRJ',
    defaultMessage:
      'Annual budget (often Capital Expense or CapEx) to replace or perform a major overhaul on assets and equipment that have reached the end of their economic and useful life. ',
  },
  lifeAssetsExtLabel: {
    id: 'bf5xVZ',
    defaultMessage: '% Reduction in CapEx Budget Need',
  },
  lifeAssetsExtDescTooltip: {
    id: 'XdVlO/',
    defaultMessage:
      'Estimated reduction in CapEx requirements to replace/overhaul assets by extending the average economic and useful life. ',
  },
  annualMroSpendLabel: {
    id: 'nE/lrt',
    defaultMessage: 'Annual MRO Spend',
  },
  annualMroSpendDescTooltip: {
    id: 'Hurwlg',
    defaultMessage:
      'Annual spend in MRO materials and supplies used for maintaining and repairing assets.',
  },
  mroOverSpendReduceLabel: {
    id: 'sz0mWm',
    defaultMessage: '% MRO Spend Reduction',
  },
  mroOverSpendReduceDescTooltip: {
    id: 'Yyxfsf',
    defaultMessage:
      'Estimated reduction in MRO inventory spend by increasing strategic and disciplined procurement of material and parts (e.g., reducing unnecessary spend for MRO inventory that is already on hand or paying price premiums for expedite shipping). ',
  },
  asstMgmtToolsCostLabel: {
    id: 'Rgz9KA',
    defaultMessage: 'Annual Cost to Support Current Asset Mgmt Tools',
  },
  asstMgmtToolsCostDescTooltip: {
    id: 'TvfET6',
    defaultMessage:
      'Total current annual cost of asset management related applications and tools (including licensing, infrastructure, and support cost). ',
  },
  asstMgmtToolsCostReduceLabel: {
    id: 'B/MevZ',
    defaultMessage: '% Reduction of Asset Mgmt Tools Support Cost',
  },
  asstMgmtToolsCostReduceDescTooltip: {
    id: '60j+mP',
    defaultMessage:
      'Estimated cost reduction from sunsetting and consolidating disparate asset management related tools into one asset management platform. ',
  },
  chartHeading: {
    id: 'yaMHMB',
    defaultMessage: 'Results',
  },
  benefit: {
    id: '45ZkgK',
    defaultMessage: 'Benefit',
  },
  category: {
    id: 'ccXLVi',
    defaultMessage: 'Category',
  },
  maintenancePersonProdTable: {
    id: 'xRglVq',
    defaultMessage: 'Increase maintenance productivity',
  },
  maintenanceCostReduceTable: {
    id: 'YmJvtm',
    defaultMessage: 'Reduce external maintenance spend',
  },
  inventoryCostReduceTable: {
    id: 'LG9hno',
    defaultMessage: 'Reduce MRO parts and supplies cost',
  },
  assetUtilPerformanceTable: {
    id: 'Dgnwqr',
    defaultMessage: 'Reduce downtime cost',
  },
  assetCapExOptTable: {
    id: 'wJphaF',
    defaultMessage: 'Extend useful life of assets',
  },
  itCostReduceTable: {
    id: 'l5I6KL',
    defaultMessage: 'Rationalize asset management tools',
  },
  reportHeading: {
    id: 'WXSfCt',
    defaultMessage: 'See your potential benefit',
  },
  reportSubHeading: {
    id: 'yMtFfC',
    defaultMessage: 'Your answer summary:',
  },
  reportTableHeading_1: {
    id: 'rCMlHN',
    defaultMessage: 'Benefit category',
  },
  reportTableHeading_2: {
    id: '3/uPTe',
    defaultMessage: 'Benefit value',
  },
  reportTotalHeading: {
    id: '11KrYT',
    defaultMessage: 'Estimated annual total',
  },
  reportTotalDisclaimer: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  reportTotalText: {
    id: 'hjHa0A',
    defaultMessage: 'Ready to move forward?',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  returnToROI: {
    id: 'E//Dx8',
    defaultMessage: 'Return to ROI',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  calculationMessage: {
    id: 'E1Gwsp',
    defaultMessage: 'Estimated 3-year savings',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  contactInfo2: {
    id: 'fJD4UX',
    defaultMessage:
      'You may qualify for volume discounting! Request a quote for the best possible price.',
  },
  contactUs: {
    id: 'zEVTyS',
    defaultMessage: 'Get more information',
  },
  detailedReportButton: {
    id: 'M/8l3Y',
    defaultMessage: 'Detailed report',
  },
  GoToPEButton: {
    id: 'YbVY9t',
    defaultMessage: 'Price estimator',
  },
  startOverButton: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  estimatedRoi: {
    id: 'hxKOo2',
    defaultMessage: 'Estimated ROI',
  },
  getQuoteButton: {
    id: 'zEVTyS',
    defaultMessage: 'Get more information',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: 'EPIw8h',
    defaultMessage: 'The MAS ROI is available in',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  footnoteOne1: {
    id: '7RkkyX',
    defaultMessage:
      'The estimated benefit potential is illustrative of results achieved by IBM clients with financial and operational asset maintenance profiles comparable to the inputs you provided. The results shown by this benefit estimator are provided for illustrative purposes only, may not be accurate or applicable to you, and will vary based on aspects such as your asset management maturity, current state capabilities, and type of assets in scope. Results from this calculator should not be relied upon or seen as a guarantee regarding the actual benefits you may achieve and will not create any liability or obligation for IBM. For a more specific exploration of the benefits of Maximo in the context of your operations, please contact your IBM Sales or Business Partner Representative.',
  },
  footnoteOne2: {
    id: 'gB46oC',
    defaultMessage:
      ' results reported by a sample (PDF, 915KB) of IBM customers',
  },
  footnoteOne3: {
    id: 'KLJgiR',
    defaultMessage:
      ' with factors comparable to your inputs based on customers’ reported data, consistent linear spend, and other technical and financial assumptions. There may be additional unaccounted for costs related to the use and deployment of MAS that are not accounted for with this calculator. For a more precise estimate, submit a request for more information to obtain a savings estimate unique to your environment. The results shown by the tool are provided for illustrative purposes only, may not be accurate or applicable to you, and will vary based on your particular business conditions, usage, and configurations and environment, among other factors. Results from the calculator should not be relied upon, are not a guarantee or commitment to you regarding any potential or actual financial results you may achieve, may not be incorporated into any contract, and will not create any liability or obligation for IBM. The calculator is provided on an “AS IS” basis, without warranty of any kind.',
  },
  export_to_pdf: {
    id: 'ZGcMOL',
    defaultMessage: 'Register for a detailed PDF',
  },
  pdfGenerated: {
    id: 'F9LZWa',
    defaultMessage: 'Your Export is being generated',
  },
  pdfCompleted: {
    id: 'zzXs9O',
    defaultMessage: 'Your Export is completed',
  },
  pdfError: {
    id: '2gydxl',
    defaultMessage: 'Your Export is incomplete',
  },
  estimatedTotal: {
    id: '11KrYT',
    defaultMessage: 'Estimated annual total',
  },
  stickyNavTitle: {
    id: 'qZL9Ww',
    defaultMessage: 'Estimated annual benefits',
  },
  startOver: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  //
});

export default messages;
